import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-three',
  templateUrl: './feature-three.component.html',
  styleUrls: ['./feature-three.component.css']
})
export class FeatureThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
